import React, { useContext, useEffect, useState } from 'react';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { DataContext } from '../pagesMains/GravesManagers/Graves';
import { addRecordToCache, createFetchDataServer, getTableData } from '../../../database/fetchData';
import { GlobalContext } from '../../../App';
import { fullSelectedBlocks, fullSelectedCemeteries, fullSelectedPlots } from '../plagins/data/multiSelectedForm';

function RowCreate({ plotId, onRowCreated = () => {} }) {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormRows.data);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataRow, getEntityByAttr, getEntitiesByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const { value } = location.state || {};

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const { token } = useContext(GlobalContext);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValuesRow, setFormValuesRow] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  const [loading, setLoading] = useState(true); // מצב טעינה
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name === 'cemeteryId' || field.name === 'blockId' || field.name === 'plotId' ? true : false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled,
        required: field.name === 'spouse' && formValuesRow.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {
    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.cemeteryId)));
    setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', data?.blockId)));
  };
  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (value?.unicId) {
    }
    if (plotId) {
      const data = getEntityByAttr(context?.contextPlots, 'unicId', plotId);
      let newFormValues = { ...formValuesRow, cemeteryId: data?.cemeteryId, blockId: data?.blockId, plotId: data?.unicId };

      console.log('step0: ', newFormValues);

      fieldAuto(data);

      setFormValuesRow(newFormValues);
    }
  };
  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);

  const handleChange = (event) => {
    setFormValuesRow({ ...formValuesRow, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    let rows = context?.contextRows?.filter((row) => row?.plotId === formValuesRow?.plotId)?.filter((row) => row?.unicId !== formValuesRow);

    columns.forEach((field) => {
      if (field.required && !formValuesRow[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }

      if (field.notRepeat && formValuesRow[field.name]) {
        if (rows.some((item) => item[field.name] === formValuesRow[field.name])) {
          tempErrors[field.name] = `הערך ${formValuesRow[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      let updatedFormValues = { ...formValuesRow };
      delete updatedFormValues.cemeteryId;
      delete updatedFormValues.blockId;

      setLoadingData(true);

      const unicId = uuidv4()

      // שליחה לשרת עם הערך החדש
      let res = await addOrUpdateDataRow(updatedFormValues, unicId);
      if (res === 200) {
        setLoadingData(false);

        context?.setContextRows((prev) => {
          const tempPlot = context?.contextPlots?.find((p) => p?.unicId === formValuesRow?.plotId);
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId,
            cemeteryNameHe: tempPlot?.cemeteryNameHe, cemeteryNameEn: tempPlot?.cemeteryNameEn, cemeteryId: tempPlot?.cemeteryId,
            blockNameHe: tempPlot.blockNameHe, blockNameEn: tempPlot.blockNameEn, plotNameHe: tempPlot.plotNameHe, plotNameEn: tempPlot.plotNameEn,
            availableSum: 0, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: 0 };
            
          //   // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataRows');

          if (existingIndex !== -1) {
            //     // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            //     // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });

        // קריאה לפונקציה שהועברה ב-prop עם המידע של השורה החדשה
        if (onRowCreated) {
          onRowCreated(updatedFormValues);
        }

        const submitEvent = new CustomEvent('CustomDialog');
        window.dispatchEvent(submitEvent);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows) {
          setLoading(false);
        }
      } else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['rows'], token, handlePartialUpdate);

        fetchDataServer(['cemeteries', 'blocks', 'plots'], token);
      }
    }
    loadTableData();
  }, []);

  return (
    <>
      <FormTemplate
        btn={'שמור'}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={formValuesRow}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        local={true}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots
        }}
      />
      {(loading || loadingData) && <LoadingOverlay />}
    </>
  );
}

export default RowCreate;
